import { useState } from 'react';

const faqs = [
  {
    q: 'كيف يمكنني تقديم طلب؟',
    a: 'يمكنك تصفح المنتجات من خلال المتجر، إضافتها إلى السلة، ثم الضغط على "إتمام الطلب" وملء بياناتك. نتيح لك الدفع عند الاستلام، دون الحاجة لبطاقة ائتمان.',
  },
  {
    q: 'ما هي مدة التوصيل؟',
    a: 'نقوم بتوصيل الطلبات داخل فلسطين خلال 2-5 أيام عمل. التوصيل مجاني للطلبات التي تزيد قيمتها عن 200 شيكل.',
  },
  {
    q: 'هل يمكنني إرجاع المنتج؟',
    a: 'نعم، يمكنك إرجاع المنتج خلال 14 يوماً من تاريخ الاستلام، شرط أن يكون بحالته الأصلية وتغليفه الأصلي. يرجى قراءة سياسة الإرجاع كاملةً في صفحة الشروط والأحكام.',
  },
  {
    q: 'كيف يمكنني تتبع طلبي؟',
    a: 'بعد تقديم الطلب، يمكنك استخدام رقم الهاتف ورقم الطلب في صفحة "تتبع الطلب" لمعرفة حالة طلبك.',
  },
  {
    q: 'هل يوجد ضمان على الأجهزة؟',
    a: 'جميع منتجاتنا تأتي مع ضمان شامل لمدة 5 سنوات. يمكنك قراءة تفاصيل الضمان في صفحة الضمان.',
  },
  {
    q: 'كيف يمكنني التواصل مع خدمة العملاء؟',
    a: 'يمكنك الاتصال بنا على الرقم +972 59 504 2586 أو مراسلتنا عبر صفحة "اتصل بنا".',
  },
];

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState(null);

  return (
    <div className="min-h-screen bg-black py-16 px-4" dir="rtl">
      <div className="max-w-3xl mx-auto text-white">
        <h1 className="text-4xl font-black mb-8">الأسئلة الشائعة</h1>
        <div className="space-y-4">
          {faqs.map((faq, i) => (
            <div key={i} className="border border-neutral-800 rounded-xl overflow-hidden">
              <button
                onClick={() => setOpenIndex(openIndex === i ? null : i)}
                className="w-full text-right p-5 bg-neutral-950 hover:bg-neutral-900 flex justify-between items-center"
              >
                <span className="font-bold text-white">{faq.q}</span>
                <span className="text-red-500 text-xl">{openIndex === i ? '−' : '+'}</span>
              </button>
              {openIndex === i && (
                <div className="p-5 bg-neutral-900 text-neutral-300 leading-relaxed">
                  {faq.a}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}